var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoney(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.5 4H18.5L16.375 8.125H13.625L11.5 4Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#FD2D23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.5 8.125H17.5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#FD2D23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M12.875 8.25C8.25 10.625 5 15.375 5 19.5C5 23.875 8.625 26.25 15 26.25C21.375 26.25 25 23.875 25 19.5C25 15.375 21.75 10.625 17.125 8.25",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#FD2D23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M17.375 15.125C16.875 14.375 16 14 15 14C13.625 14 12.625 14.75 12.625 15.75C12.625 18.125 17.375 17 17.375 19.375C17.375 20.375 16.375 21.125 15 21.125C13.875 21.125 13 20.625 12.5 19.875",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#FD2D23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M15 12.75V14",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#FD2D23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M15 21.125V22.375",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#FD2D23"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoney);
export default __webpack_public_path__ + "static/media/money.4dfd88fda93bc179a4a1d84365ad7acd.svg";
export { ForwardRef as ReactComponent };